/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cta_Default_ButtonInputs */

const en_cta_default_button = /** @type {(inputs: Cta_Default_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SCHEDULE A CONSULTATION`)
};

const pt_cta_default_button = /** @type {(inputs: Cta_Default_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AGENDE UMA CONSULTA`)
};

const es_cta_default_button = /** @type {(inputs: Cta_Default_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AGENDE UNA CONSULTA`)
};

/**
* | output |
* | --- |
* | "SCHEDULE A CONSULTATION" |
*
* @param {Cta_Default_ButtonInputs} inputs
* @param {{ locale?: "en" | "pt" | "es" }} options
* @returns {LocalizedString}
*/
export const cta_default_button = /** @type {((inputs?: Cta_Default_ButtonInputs, options?: { locale?: "en" | "pt" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cta_Default_ButtonInputs, { locale?: "en" | "pt" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt") return pt_cta_default_button(inputs)
	if (locale === "es") return es_cta_default_button(inputs)
	return en_cta_default_button(inputs)
});